import http from "./httpService";
import { apiUrl } from "../config.json";
const apiEndpointOPTOUT = apiUrl + "/api/TB_OPTOut";
const apiEndpoint = apiUrl + "/api/GetCashU_MT_Filer_ALL/false/false/";
const apiEndpoint_replyed = apiUrl + "/api/GetCashU_MT_Filer_ALL_LastMonth";
const apiEndpoint_Correct = apiUrl + "/api/GetTB_CorrectWordsList_All";
const apiEndpoint_Meaning = apiUrl + "/api/TB_Words_Meaning_ALL";
const apiEndpoint_Muraqeeb =
  apiUrl + "/api/GetCashU_MT_Filer_ALL_Muraqeeb/true";
const apiEndpoint_Delete = apiUrl + "/api/GetCashU_MT_ALL_Delete";
const apiEndpoint_Reply = apiUrl + "/api/GetCashU_MT_ALL_Reply/false/false/";
const apiEndpointEdit = apiUrl + "/api/PostCashU_MT";
const apiEndpointAllOldData = apiUrl + "/api/GetCashU_MT_GetNoInfo/"; // "/api/GetCashU_MT_Filer_ALL_OldData/true/2017";
const apiEndpointNonReplyMobData = apiUrl + "/api/GetCashU_MT_GetNoInfo_NoReply/"; // "/api/GetCashU_MT_Filer_ALL_OldData/true/2017";
const apiEndpoint_GNI = apiUrl + "/api/GetCashU_MT_GetNoInfo/";
const apiEndpoint_GetDreamsThisMonth = apiUrl + "/api/GetDreamsThisMonth/";
const apiEndpointSearchMob = apiUrl + "/api/GetSearchMob/";
const apiEndpointSearch = apiUrl + "/api/GetSearch/";
const apiEndpointREFRESHDATA = apiUrl + "/api/GetCashU_MT_LOCKED_MURAQEEB/";

const apiEndpointGetCashU_MT_locked = apiUrl + "/api/GetCashU_MT_locked/";
const apiEndpointGetCashU_MT_lockedReplyID = apiUrl + "/api/GetCashU_MT_lockedReplyID/";
function DreamUrl(id) {
  return `${apiEndpoint}/${id}`;
}
//GetCashU_MT_GetNoInfo_NoReply

export function getCashU_MT_locked(username, mob, islock) {
  const data = localStorage.getItem("token");
  mob = mob.replace("+", "");
  username = username.replace("@salmustasharak.com", "");
  //console.log(apiEndpointGetCashU_MT_locked+username +'/'+mob+'/'+islock);
  return http.get(apiEndpointGetCashU_MT_locked + username + '/' + mob + '/' + islock, { headers: { Authorization: `Bearer ${data}` } });
}

export function getCashU_MT_lockedReplyID(username, mob, islock, ReplyID) {
  const data = localStorage.getItem("token");
  mob = mob.replace("+", "");
  username = username.replace("@salmustasharak.com", "");
  //console.log(apiEndpointGetCashU_MT_lockedReplyID+username +'/'+mob+'/'+islock +'/'+ReplyID);
  return http.get(apiEndpointGetCashU_MT_lockedReplyID + username + '/' + mob + '/' + islock + '/' + ReplyID, { headers: { Authorization: `Bearer ${data}` } });
}
export function getDreamsREFRESHDATA(no) {
  const data = localStorage.getItem("token");
  return http.get(apiEndpointREFRESHDATA + no, { headers: { Authorization: `Bearer ${data}` } });
}

export function getDreams() {

  const data = localStorage.getItem("token");
  let userName = localStorage.getItem("userName");
  userName = userName.replace("@salmustasharak.com", "");
  //console.log(data);
  return http.get(apiEndpoint + userName, { headers: { Authorization: `Bearer ${data}` } });




}
export function getDreamsThisMonth() {
  const data = localStorage.getItem("token");
  return http.get(apiEndpoint_GetDreamsThisMonth, { headers: { Authorization: `Bearer ${data}` } });
}
export function getDreamsRepled() {
  const data = localStorage.getItem("token");
  return http.get(apiEndpoint_replyed, { headers: { Authorization: `Bearer ${data}` } });
}
export function getDreamsNoInfo(no) {
  const data = localStorage.getItem("token");
  return http.get(apiEndpoint_GNI + no.replace('+', ''), { headers: { Authorization: `Bearer ${data}` } });
}
export function getDreamsReply() {
  const data = localStorage.getItem("token");
  let userName = localStorage.getItem("userName");
  userName = userName.replace("@salmustasharak.com", "");

  return http.get(apiEndpoint_Reply + userName, { headers: { Authorization: `Bearer ${data}` } });
}
export function getDreamsDeleted() {
  const data = localStorage.getItem("token");
  return http.get(apiEndpoint_Delete, { headers: { Authorization: `Bearer ${data}` } });
}
export function getDreamsMuraqeeb() {
  const data = localStorage.getItem("token");
  return http.get(apiEndpoint_Muraqeeb, { headers: { Authorization: `Bearer ${data}` } });
}
export function getOldDreams(mob) {
  const data = localStorage.getItem("token");
  return http.get(apiEndpointAllOldData + mob, { headers: { Authorization: `Bearer ${data}` } });
}

export function getNonReplyMobDataDreams(mob) {
  const data = localStorage.getItem("token");
  return http.get(apiEndpointNonReplyMobData + mob, { headers: { Authorization: `Bearer ${data}` } });
}

export function getSearch(words, year) {
  const data = localStorage.getItem("token");
  return http.get(apiEndpointSearch + words, { headers: { Authorization: `Bearer ${data}`, } });
}

export function getSearchMob(mob) {
  const data = localStorage.getItem("token");
  return http.get(apiEndpointSearchMob + mob, { headers: { Authorization: `Bearer ${data}` } });
}


export function getWrongWords() {
  return http.get(apiEndpoint_Correct);
}
export function getTafseer() {
  return http.get(apiEndpoint_Meaning);
}

export function getDream(dreamId) {
  return http.get(DreamUrl(dreamId));
}

export function saveDream(Dream) {
  /*   if (Dream._id) {
    const body = { ...Dream };
    delete body._id;
    return http.put(DreamUrl(Dream._id), body);
  } */
  const data = localStorage.getItem("token");
  return http.post(apiEndpointEdit, Dream, { headers: { Authorization: `Bearer ${data}` } });
}
export function saveOPTOUT(mob) {
  /*   if (Dream._id) {
    const body = { ...Dream };
    delete body._id;
    return http.put(DreamUrl(Dream._id), body);
  } */
  const data = localStorage.getItem("token");
  return http.post(apiEndpointOPTOUT, mob, { headers: { Authorization: `Bearer ${data}` } });
}
export function saveBulkDream(Dreams) {
  /*   if (Dream._id) {
    const body = { ...Dream };
    delete body._id;
    return http.put(DreamUrl(Dream._id), body);
  } */
  const data = localStorage.getItem("token");
  return http.post(apiUrl + "/api/PostCashU_MT_Bulk", Dreams, { headers: { Authorization: `Bearer ${data}` } });
}

export function saveWW(Dream) {
  /*   if (Dream._id) {
      const body = { ...Dream };
      delete body._id;
      return http.put(DreamUrl(Dream._id), body);
    } */

  return http.post(apiEndpointEdit, Dream);
}

export function deleteDream(DreamId) {
  return http.delete(DreamUrl(DreamId));
}



// WEBPACK FOOTER //
// ./src/services/dreamService.js